import { setCookie } from './functions.js';
import { getCookie } from './functions.js';
import { getUrlParameter } from './functions.js';
import { openModal } from './functions.js';
import { imageSrc } from './functions.js';

import { lazyLoadImages, lazyLoadVideos, initializeButtonEffect } from './functions.js';

function scrollDown() {
    const scrollDown = document.querySelector('.c-scroll-down');
    if (scrollDown) {
        scrollDown.addEventListener('click', function (event) {
            event.preventDefault();

            // Find the .b-hero element
            const heroElement = document.querySelector('.b-hero__home, .b-hero__standard');

            if (heroElement) {
                // Find the first section after .b-hero
                const nextSection = heroElement.nextElementSibling;

                if (nextSection && nextSection.tagName.toLowerCase() === 'section') {
                    nextSection.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            }
        });
    }
}
scrollDown();

// Keep the existing code for non-slider buttons
initializeButtonEffect();
window.addEventListener('DOMContentLoaded', initializeButtonEffect);
window.addEventListener('load', initializeButtonEffect);

// Add a timeout to catch any elements that render late
setTimeout(initializeButtonEffect, 4000);

// Keep your existing Revolution Slider support
if (window.jQuery && window.jQuery.fn.revolution) {
    // Run when the slider has finished loading
    jQuery(document).on('revolution.slide.onloaded', function() {
        // Run once immediately after slider loads
        setTimeout(initializeButtonEffect, 100);

        // Run again when ANY layer finishes animating in
        jQuery(document).on('revolution.slide.layeraction', function(event, data) {
            // Check if this is a layer that has finished animating in
            if (data.eventtype === 'enteredstage') {
                // Short delay to ensure animations complete and elements are rendered
                setTimeout(initializeButtonEffect, 200);
            }
        });

        // Also run when changing slides
        jQuery(document).on('revolution.slide.onchange', function() {
            // Slightly longer delay for slide changes
            setTimeout(initializeButtonEffect, 300);
        });
    });
}




function countUp(useLeadingZeros = false) {
    // Select all spans with a data-counter attribute
    const counters = document.querySelectorAll('[data-counter]');
    // console.log("Number of counters found:", counters.length); // Debugging

    if (counters.length === 0) {
        // console.log("No counters found. Check your HTML structure.");
        return;
    }

    // Function to animate the counter
    const animateCounter = (counter) => {
        const target = +counter.getAttribute('data-counter'); // Get the target number
        const speed = 200; // Speed of the animation
        const increment = target / speed; // Increment per frame
        let count = 0;

        // Get the number of digits in the target number
        const numberOfDigits = target.toString().length;

        // Set initial content with leading zeros if enabled
        if (useLeadingZeros) {
            counter.textContent = '0'.repeat(numberOfDigits);
        } else {
            counter.textContent = '0'; // Or some other placeholder
        }

        // Update the counter text
        const updateCounter = () => {
            count += increment; // Increment count
            if (count < target) {
                const newText = Math.ceil(count).toString();
                counter.textContent = useLeadingZeros
                    ? newText.padStart(numberOfDigits, '0') // Pad with leading zeros if enabled
                    : newText; // No padding
                requestAnimationFrame(updateCounter); // Continue updating
            } else {
                counter.textContent = useLeadingZeros
                    ? target.toString().padStart(numberOfDigits, '0') // Final value with leading zeros if enabled
                    : target.toString(); // No padding
            }
        };

        updateCounter(); // Start the animation
    };

    // Create an Intersection Observer to trigger animation when element is in view
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounter(entry.target); // Animate the counter
                observer.unobserve(entry.target); // Stop observing after animation starts
            }
        });
    }, {
        threshold: 0.1 // Trigger when 10% of the element is visible
    });

    // Observe each counter element
    counters.forEach(counter => {
        observer.observe(counter);
    });
}

// document.addEventListener("DOMContentLoaded", () => countUp(true));
countUp(false);

window.addEventListener('load', () => {
    lazyLoadImages();
    document.addEventListener('facetwp-loaded', lazyLoadImages);
    document.addEventListener('facetwp-refresh', lazyLoadImages);
});

function closeModal() {
    const html = document.querySelectorAll('html');
    const elements = document.querySelectorAll('.overlay, .close');
    var modal = document.querySelector('.modal');
    elements.forEach((el) => {
        el.addEventListener('click', (e) => {
            modal.classList.toggle('active');
            html[0].classList.toggle('lock-scroll');
            e.preventDefault();
            // toggleModal(modal);
        });
    });
}
// window.addEventListener('DOMContentLoaded', closeModal);

// Function to check if the URL is a video link
function isVideoLink(url) {
    return (
        url.includes('mp4') ||
        url.includes('3gp') ||
        url.includes('ogg') ||
        url.includes('youtu') ||
        url.includes('vimeo')
    );
}

// Function to extract YouTube video ID from URL
function extractYouTubeVideoId(url) {
    var match = url.match(/v=([a-zA-Z0-9_-]+)/);
    if (match) {
        // console.log(match[1]);
        return match[1];
    }
    return '';
}

// Function to extract Vimeo video ID from URL
function extractVimeoVideoId(url) {
    var match = url.match(/\/(\d+)/);
    if (match) {
        return match[1];
    }
    return '';
}

function initSliders() {
    const sliders = document.querySelectorAll('.c-slider');

    sliders.forEach(slider => {
        const tabs = slider.querySelectorAll('.c-slider__tab-button');
        const slides = slider.querySelectorAll('.c-slider__slide');
        const timerBar = slider.querySelector('.c-slider__timer-current');
        const pauseButton = slider.querySelector('.c-slider__pause-button');

        const slideDuration = 5000; // Duration for each slide in milliseconds
        let currentSlideIndex = 0; // Start with the first slide (0 index)
        let timerInterval;
        let isPaused = false;
        let elapsedTime = 0; // Track the elapsed time when paused
        let lastStartTime = 0; // Store the last start time for correct calculations
        let isInView = false; // Track if the slider is in view

        // SVG icons as inline SVG
        const playIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M8 5v14l11-7z"/></svg>`;
        const pauseIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>`;

        function scrollToActiveTab(slider) {
            const tabNavigation = slider.querySelector('.c-slider__tab-navigation');
            const activeTab = slider.querySelector('.c-slider__tab-button.active');

            if (tabNavigation && activeTab) {
                // Calculate the position of the active tab relative to the container
                const containerLeft = tabNavigation.scrollLeft;
                const tabOffsetLeft = activeTab.offsetLeft;
                const tabWidth = activeTab.offsetWidth;
                const containerWidth = tabNavigation.offsetWidth;

                // Scroll so the active tab is centered (or left-aligned if desired)
                const scrollTo = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);

                tabNavigation.scrollTo({
                    left: scrollTo,
                    behavior: 'smooth'
                });
            }
        }

        function showSlide(index) {
            slides.forEach((slide, slideIndex) => {
                slide.classList.toggle('active', slideIndex === index);
            });

            tabs.forEach((tab, tabIndex) => {
                tab.classList.toggle('active', tabIndex === index);
            });

            // Scroll to the active tab
            scrollToActiveTab(slider);

            // Resize slider container based on the height of the active slide
            resizeSlider();
        }

        function resizeSlider() {
            const activeSlide = slider.querySelector('.c-slider__slide.active');
            const navHeight = slider.querySelector('.c-slider__tab-navigation').offsetHeight;
            const slidesParent = activeSlide.closest('.c-slider');

            if (activeSlide) {
                const slideHeight = activeSlide.scrollHeight;
                slidesParent.style.height = `${slideHeight + navHeight * 2}px`;
            }
        }

        function startTimer() {
            if (timerInterval) {
                clearInterval(timerInterval);
            }

            lastStartTime = Date.now() - elapsedTime;
            timerBar.style.width = `${(elapsedTime / slideDuration) * 100}%`;

            timerInterval = setInterval(() => {
                if (isPaused || !isInView) return;

                elapsedTime = Date.now() - lastStartTime;
                const percent = Math.min((elapsedTime / slideDuration) * 100, 100);
                timerBar.style.width = `${percent}%`;

                if (percent >= 100) {
                    timerBar.style.width = '100%';
                    clearInterval(timerInterval);
                    nextSlide();
                }
            }, 100);
        }

        function nextSlide() {
            currentSlideIndex = (currentSlideIndex + 1) % slides.length;
            showSlide(currentSlideIndex);
            elapsedTime = 0; // Reset elapsed time when switching slides
            startTimer();
        }

        function togglePause() {
            isPaused = !isPaused;
            updatePauseIcon(); // Ensure the icon is updated correctly
            if (isPaused) {
                clearInterval(timerInterval);
            } else {
                startTimer();
            }
        }

        function updatePauseIcon() {
            pauseButton.innerHTML = isPaused ? playIcon : pauseIcon;
            pauseButton.classList.toggle('paused', isPaused);
        }

        pauseButton.innerHTML = pauseIcon;

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                currentSlideIndex = index;
                showSlide(currentSlideIndex);
                elapsedTime = 0; // Reset elapsed time on tab change
                startTimer();
            });
        });

        pauseButton.addEventListener('click', togglePause);

        function initializeSlider() {
            if (!isPaused && isInView) {
                showSlide(currentSlideIndex);
                startTimer();
            }
        }

        function stopSlider() {
            clearInterval(timerInterval);
            isPaused = true; // Set to paused when out of view
            updatePauseIcon(); // Update the icon to reflect the paused state
        }

        // Intersection Observer to detect when the slider is in view
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    isInView = true;
                    isPaused = false; // Resume if it was paused
                    updatePauseIcon(); // Update the icon to reflect the play state
                    initializeSlider(); // Start or resume the slider when it comes into view
                } else {
                    isInView = false;
                    stopSlider(); // Stop the slider when it goes out of view
                }
            });
        }, { threshold: 0.5 }); // Trigger when 50% of the slider is in view

        observer.observe(slider);

        // Ensure correct resizing after images and other resources are fully loaded
        window.addEventListener('load', () => {
            // Set initial height and show the first slide
            showSlide(currentSlideIndex);
            resizeSlider();
        });
        window.addEventListener('resize', resizeSlider);

        // Initial height setting when the script runs
        showSlide(currentSlideIndex);
        resizeSlider();
    });
}

initSliders();

function cursor() {
    // Get the circle element
    const cursor = document.getElementById('cursor');
    if(!cursor) {
        return;
    }

    const text = cursor.querySelector('span');

    let mouseX = 0;
    let mouseY = 0;
    let cursorX = 0;
    let cursorY = 0;
    const speed = .1;

    // Function to smoothly move the circle toward the cursor
    function animateCircle() {
        // Lerp the circle's position toward the cursor's position
        cursorX += (mouseX - cursorX) * speed;
        cursorY += (mouseY - cursorY) * speed;

        // Update the circle's position
        cursor.style.left = `${cursorX}px`;
        cursor.style.top = `${cursorY}px`;

        // Request the next frame of the animation
        requestAnimationFrame(animateCircle);
    }

    // Function to update the target position on mouse move
    function updateMousePosition(e) {
        let targetElement = e.target;
        let foundDataCursor = false;

        // Traverse up the DOM tree to check for `data-cursor` attribute
        while (targetElement) {
            if (targetElement.hasAttribute('data-cursor')) {
                foundDataCursor = true;
                break;
            }
            targetElement = targetElement.parentElement;
        }

        // Update mouseX and mouseY regardless of hovering state
        mouseX = e.pageX;
        mouseY = e.pageY;

        if (foundDataCursor) {
            // Immediately position the circle at the cursor before showing it
            cursorX = mouseX;
            cursorY = mouseY;
            cursor.style.left = `${cursorX}px`;
            cursor.style.top = `${cursorY}px`;

            const cursorText = targetElement.getAttribute('data-cursor-text');

            if(cursorText) {
                text.textContent = cursorText;
            } else {
                text.textContent = '';
            }

            // Show the circle
            cursor.classList.add('show');
        } else {
            // Hide the circle when not on a target element
            cursor.classList.remove('show');
        }
    }

    // Add event listener to update mouse position
    document.addEventListener('mousemove', updateMousePosition);

    // Start the animation loop
    animateCircle();
}
cursor();






function animateRotate() {
    // Select all elements with data-animation="rotate"
    const circles = document.querySelectorAll('[data-animation="rotate"]');

    // Create a Map to keep track of active scroll event listeners
    const activeElements = new Map();

    // Create an IntersectionObserver to track elements entering and leaving the viewport
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const circle = entry.target;

            function rotateOnScroll() {
                if (entry.isIntersecting) {
                    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                    const depth = parseFloat(circle.getAttribute('data-depth')) || 1;
                    const rotation = scrollPosition * depth;
                    circle.style.transform = `rotate(${rotation}deg)`;
                }
            }

            if (entry.isIntersecting) {
                // Add scroll event listener when the element is in view
                if (!activeElements.has(circle)) {
                    activeElements.set(circle, rotateOnScroll);
                    window.addEventListener('scroll', rotateOnScroll);
                    circle.style.opacity = '1';
                }
                // Rotate immediately when the element comes into view
                rotateOnScroll();
            } else {
                // Remove the scroll event listener when the element is out of view
                if (activeElements.has(circle)) {
                    window.removeEventListener('scroll', activeElements.get(circle));
                    activeElements.delete(circle);
                    // Reset transform to avoid continued rotation when out of view
                    circle.style.transform = '';
                }
            }
        });
    }, { threshold: 0.1 }); // Adjust threshold as needed

    // Observe each circle element
    circles.forEach(circle => {
        observer.observe(circle);
    });
}
animateRotate();

function animateTranslate() {
    const elements = document.querySelectorAll('[data-animation^="translate"]');
    const activeElements = new Map();

    function getParentSection(element) {
        return element.closest('section');
    }

    function calculateTransform(element, scrollPosition) {
        const parentSection = getParentSection(element);
        const sectionTop = parentSection.getBoundingClientRect().top + window.pageYOffset;
        const depth = parseFloat(element.getAttribute('data-depth')) || 1;
        const multiplier = parseFloat(element.getAttribute('data-multiplier')) || 1;
        const animation = element.getAttribute('data-animation');
        const offset = scrollPosition - sectionTop;

        let translateX = 0;
        let translateY = 0;

        switch (true) {
            case animation.includes('translate-up'):
                translateY = offset * -1 * depth * multiplier;
                break;
            case animation.includes('translate-down'):
                translateY = offset * depth * multiplier;
                break;
            case animation.includes('translate-left'):
                translateX = offset * -1 * depth * multiplier;
                break;
            case animation.includes('translate-right'):
                translateX = offset * depth * multiplier;
                break;
        }

        return { translateX, translateY };
    }

    function applyTransform(element, scrollPosition) {
        const { translateX, translateY } = calculateTransform(element, scrollPosition);
        element.style.transform = `translate(${translateX}px, ${translateY}px)`;
    }

    function handleScroll() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        elements.forEach(element => {
            const parentSection = getParentSection(element);
            const sectionRect = parentSection.getBoundingClientRect();
            if (sectionRect.bottom > 0 && sectionRect.top < window.innerHeight) {
                applyTransform(element, scrollPosition);
            }
        });
    }

    function applyInitialTransforms() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        elements.forEach(element => {
            applyTransform(element, scrollPosition);
        });
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const element = entry.target;

            if (entry.isIntersecting) {
                element.style.opacity = '1';
                applyTransform(element, window.pageYOffset || document.documentElement.scrollTop);

                if (!activeElements.has(element)) {
                    const boundScrollHandler = () => handleScroll();
                    window.addEventListener('scroll', boundScrollHandler);
                    activeElements.set(element, boundScrollHandler);
                }
            } else {
                if (activeElements.has(element)) {
                    window.removeEventListener('scroll', activeElements.get(element));
                    activeElements.delete(element);
                }
                applyTransform(element, window.pageYOffset || document.documentElement.scrollTop);
            }
        });
    }, { threshold: 0.1 });

    elements.forEach(element => observer.observe(element));

    // Initial application of transforms to handle visibility just below the fold
    applyInitialTransforms();
    window.addEventListener('scroll', handleScroll);
}
animateTranslate();

function magnetic() {
    // Linear interpolation (lerp) function
    function lerp(start, end, factor) {
        return start + (end - start) * factor;
    }

    const magneticElements = document.querySelectorAll('.u-magnetic');
    magneticElements.forEach(magnetic => {

        const parent = magnetic.parentElement;

        if (!parent) return;

        // Handle mouse move event
        function handleMouseMove(e) {
            const button = e.currentTarget; // This is the .swiper-button-prev or .swiper-button-next
            if (!magnetic) return; // Ensure there's a magnetic element

            const rect = magnetic.getBoundingClientRect();

            // Calculate target position relative to the parent button
            const targetX = e.clientX - rect.left - rect.width / 2;
            const targetY = e.clientY - rect.top - rect.height / 2;

            // Apply lerp to smooth movement
            button.lerpX = lerp(button.lerpX || 0, targetX * 0.3, 0.1);
            button.lerpY = lerp(button.lerpY || 0, targetY * 0.3, 0.1);

            // Set the transform on the parent button
            button.style.transform = `translate(${button.lerpX}px, ${button.lerpY}px)`;

            // Request the next animation frame
            button.animationFrame = requestAnimationFrame(() => handleMouseMove(e));
        }

        // Reset the button's position
        function resetButtonPosition(e) {
            const button = e.currentTarget;
            if (button.animationFrame) {
                cancelAnimationFrame(button.animationFrame);
            }

            function smoothReset() {
                button.lerpX = lerp(button.lerpX || 0, 0, 0.1);
                button.lerpY = lerp(button.lerpY || 0, 0, 0.1);
                button.style.transform = `translate(${button.lerpX}px, ${button.lerpY}px)`;

                if (Math.abs(button.lerpX) > 0.1 || Math.abs(button.lerpY) > 0.1) {
                    requestAnimationFrame(smoothReset);
                } else {
                    button.style.transform = 'translate(0, 0)';
                }
            }

            smoothReset();
        }

        // Add event listeners for mouse move and leave
        parent.addEventListener('mousemove', handleMouseMove);
        parent.addEventListener('mouseleave', resetButtonPosition);

    });
}

// magnetic();

// const button = document.querySelector('.swiper-button-next');
// const span = button.querySelector('span');

// button.addEventListener('mouseenter', (event) => {
//   // Calculate the cursor's position relative to the button
//   const rect = button.getBoundingClientRect();
//   const cursorX = event.clientX - rect.left;
//   const cursorY = event.clientY - rect.top;

//   // Set the initial position of the span
//   gsap.set(span, {
//     x: cursorX - span.offsetWidth / 2,
//     y: cursorY - span.offsetHeight / 2,
//     scale: 0.5,
//   });

//   // Animate the span to fill the parent div
//   gsap.to(span, {
//     scale: 1,
//     x: 0,
//     y: 0,
//     duration: 0.5,
//     ease: 'power2.out',
//   });
// });

// button.addEventListener('mouseleave', () => {
//   // Animate the span back to the center
//   gsap.to(span, {
//     scale: 0.5,
//     x: 0,
//     y: 0,
//     duration: 0.5,
//     ease: 'power2.out',
//     onComplete: () => {
//       // Reset the span's scale and position when the animation completes
//       gsap.set(span, { scale: 1, x: 0, y: 0 });
//     },
//   });
// });




// document.addEventListener('DOMContentLoaded', () => {
//     const sliderNav = document.querySelector('.c-slider__tab-navigation');

//     if (!sliderNav) return; // Exit if the element is not found

//     let isDragging = false;
//     let startX = 0;
//     let scrollLeft = 0;

//     // Mouse Down Event - Start Dragging
//     sliderNav.addEventListener('mousedown', (e) => {
//         isDragging = true;
//         sliderNav.classList.add('dragging');
//         startX = e.pageX - sliderNav.offsetLeft;
//         scrollLeft = sliderNav.scrollLeft;
//     });

//     // Mouse Up and Mouse Leave Event - Stop Dragging
//     const stopDragging = () => {
//         isDragging = false;
//         sliderNav.classList.remove('dragging');
//     };

//     sliderNav.addEventListener('mouseleave', stopDragging);
//     sliderNav.addEventListener('mouseup', stopDragging);

//     // Mouse Move Event - Handle Dragging
//     sliderNav.addEventListener('mousemove', (e) => {
//         if (!isDragging) return;
//         e.preventDefault();
//         const x = e.pageX - sliderNav.offsetLeft;
//         const walk = x - startX; // Distance moved
//         sliderNav.scrollLeft = scrollLeft - walk;
//     });

//     // Touch Start Event - Start Dragging
//     sliderNav.addEventListener('touchstart', (e) => {
//         isDragging = true;
//         startX = e.touches[0].pageX - sliderNav.offsetLeft;
//         scrollLeft = sliderNav.scrollLeft;
//     });

//     // Touch End Event - Stop Dragging
//     sliderNav.addEventListener('touchend', () => {
//         isDragging = false;
//     });

//     // Touch Move Event - Handle Dragging
//     sliderNav.addEventListener('touchmove', (e) => {
//         if (!isDragging) return;
//         e.preventDefault(); // Prevent vertical scrolling
//         const x = e.touches[0].pageX - sliderNav.offsetLeft;
//         const walk = x - startX; // Distance moved
//         sliderNav.scrollLeft = scrollLeft - walk;
//     });
// });

// document.addEventListener('DOMContentLoaded', () => {
//     const sliderNav = document.querySelector('.c-slider__tab-navigation');

//     if (sliderNav) {
//         // Calculate the full scrollable width
//         const contentWidth = sliderNav.scrollWidth;

//         // Set the width to a CSS variable or directly on the element
//         sliderNav.style.setProperty('--dynamic-width', `${contentWidth}px`);

//         // Alternatively, apply it directly to a pseudo-element via a style rule
//         const style = document.createElement('style');
//         style.textContent = `
//             .c-slider__tab-navigation::before {
//                 width: ${contentWidth}px;
//             }
//         `;
//         document.head.appendChild(style);
//     }
// });
